'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["to"];
import PropTypes from 'prop-types';
import { getFullHref } from '../../utils/history';
import CoreCanonicalLink from 'marketplace-ui-common/components/elements/CanonicalLink';
import { jsx as _jsx } from "react/jsx-runtime";
const CanonicalLink = _ref => {
  let {
      to
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CoreCanonicalLink, Object.assign({}, rest, {
    href: getFullHref(to).replace(/\/$/, '')
  }));
};
CanonicalLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};
export default CanonicalLink;